const DEFAULT_MESSAGE = "Something went wrong. Please try again.";

// Reads a thrown request error into what error UI needs:
// { status, code, message, details, requestId }.
//
// For an API error (the envelope's error, normalized onto the thrown error
// by api/axiosConfig.js), `code` is the stable lower_snake_case contract
// code to branch on and `message` is the server's text. Anything else (a
// network failure or timeout, an ALB error page, a legacy pre-4.0 Connector
// App body) has `code: null`; its message comes from a legacy body's
// `error`/`message`/`detail` string if there is one, otherwise axios's own
// message for a transport failure, otherwise `fallbackMessage`.
export function getApiErrorInfo(err, fallbackMessage = DEFAULT_MESSAGE) {
  const status = err?.response?.status ?? null;
  const requestId = err?.requestId || null;

  if (err?.isApiError) {
    return {
      status,
      code: err.code || null,
      message: err.message || fallbackMessage,
      details: err.details ?? null,
      requestId,
    };
  }

  const body = err?.response?.data;
  let legacyMessage = null;
  if (body && typeof body === "object") {
    legacyMessage =
      [body.error, body.message, body.detail].find(
        (value) => typeof value === "string" && value,
      ) || null;
  }

  return {
    status,
    code: null,
    message:
      legacyMessage ||
      (!err?.response && err?.message) ||
      fallbackMessage,
    details: null,
    requestId,
  };
}